import { render } from "./TaskSettingsPrimaryInfo.vue?vue&type=template&id=fc0c835e"
import script from "./TaskSettingsPrimaryInfo.vue?vue&type=script&lang=js"
export * from "./TaskSettingsPrimaryInfo.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./TaskSettingsPrimaryInfo.vue?vue&type=style&index=0&id=fc0c835e&module=true&lang=less"
cssModules["$style"] = style0

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__